import {BaseModel} from "../base-model";
import {BaseLinkModelSettings} from "./base-link-model-settings";
import {LINK_TYPES} from "../../../core/consts";

export class BaseNavigationModel extends BaseModel {
  type: LINK_TYPES;
  _url: String;
  settings: BaseLinkModelSettings;

  constructor(url: String, isLinkTag: Boolean, settings: BaseLinkModelSettings) {
    super();

    this._url = url;
    this.settings = settings;
    this.isLinkTag = isLinkTag;
  }

  get url() {
    return this._url?.split(/[?#]/)[0];
  }

  get search() {
    const match = this._url?.match(/\?(.*?)#/); // Matches search between ? and #
    return match ? match[1] : this._url?.includes('?') ? this._url?.split('?')[1] : null;
  }

  get hash() {
    const hashIndex = this._url?.indexOf('#');
    return hashIndex !== -1 ? this._url?.substring(hashIndex + 1) : null;
  }

  toString(): * {
    return this._url;
  }
}
